module.exports = __webpack_public_path__ + "92ef020d45548c1d915b29a0ade1e5d6.png";